/** A titled panel: a status header, a metric row, a callout, and one featured row. */
import { Surface, Vertical, Text } from './primitives';
import { PanelHeader } from './panelHeader';
import { StatTileRow } from './feedback';

export function StatusPanel({ nodeId, props = {}, data, ctx, emit, renderTemplate }) {
  const layOut = renderTemplate || props.renderTemplate;
  const tiles = Array.isArray(props.tiles) ? props.tiles : [];
  const featured = props.featured;
  const hasCallout = Boolean(props.calloutLead || props.calloutBody);
  const hasContent = props.title || props.status || tiles.length || hasCallout || featured;
  if (!hasContent) return null;

  const featuredNode = props.card && featured && layOut
    ? layOut(props.card, {
      item: featured,
      key: `${nodeId}__featured`,
      onSignal: (signal, payload, rowCtx) => emit?.(signal, payload, rowCtx),
    })
    : null;

  return (
    <Surface variant="card" props={{ padding: '4', radius: 28 }}>
      <Vertical props={{ gap: '3' }}>
        <PanelHeader title={props.title} meta={props.status} />
        {tiles.length ? (
          <StatTileRow
            // A readout row, never a one-of-N control: every tone stays visible.
            nodeId={`${nodeId}__tiles`}
            variant="metric"
            props={{ tiles, tappable: false, plated: true }}
            data={data}
          />
        ) : null}
        {hasCallout ? (
          <Surface variant="recessed" props={{ radius: 12, padding: '3' }}>
            <Text props={{ spans: [
              ...(props.calloutLead ? [{ value: props.calloutLead, bold: true }] : []),
              ...(props.calloutBody ? [{ value: ` ${props.calloutBody}` }] : []),
            ] }} />
          </Surface>
        ) : null}
        {featuredNode}
      </Vertical>
    </Surface>
  );
}

export default StatusPanel;
